export const BetStatus = {
  Lose: 0,
  Win: 1,
  Pending: 2,
};

export const BetStatusName = {
  0: 'LOSE',
  1: 'WIN',
  2: 'PENDING',
};
